module.exports = __webpack_public_path__ + "static/media/swap-light.5cfce471.svg";